<template>
    <div class="Office" v-if="lang">
        <md-whiteframe class="shadow shadow-faint">
            <div class="search search--field">
                <div class="icon">
                    <md-icon>search</md-icon>
                </div>
                <div class="input">
                    <input type="text" v-model="search.query" placeholder="Buscar consultas" style="outline:0;">
                    <span class="status">{{ searchIndicator }}</span>
                </div>
                <md-button v-if="addButton" class="md-icon-button md-raised button" @click.native="addExtraHours">
                    <md-icon>add</md-icon>
                </md-button>
                <md-button v-else class="md-icon-button md-raised button-remove" @click.native="removeExtraHours">
                    <md-icon>clear</md-icon>
                </md-button>
            </div>
        </md-whiteframe>
        <div class="table table-mobile table--office table--abs">
            <md-table-card v-if="extraHours.length > 0" class="table--wrap">
                <md-table md-sort="name" @sort="onSort" md-sort-by="name" @select="onSelect">
                    <md-table-header>
                        <md-table-row>
                            <md-table-head class="td-sort-name" md-sort-by="name"> {{ translate.pages.extrahours.index.fields.office }}</md-table-head>
                            <md-table-head class="hidden-mobile" md-sort-by="start"> {{ translate.pages.extrahours.index.fields.start }} </md-table-head>
                            <md-table-head class="hidden-mobile" md-sort-by="end">{{ translate.pages.extrahours.index.fields.end }}</md-table-head>
                            <md-table-head class="hidden-mobile" md-sort-by="reason">Motivo</md-table-head>
                            <md-table-head class="text-center hidden-mobile">{{ translate.pages.extrahours.index.fields.actions }}</md-table-head>
                        </md-table-row>
                    </md-table-header>
                    <md-table-body>
                        <md-table-row v-for="(row, rowIndex) in extraHours" :key="rowIndex" :md-item="row" md-selection>
                            <md-table-cell>
                                <img :src="srcImage(row.office.path)" height="40" width="40" class="img">
                                <span class="name">{{ row.office.name }}</span>
                            </md-table-cell>
                            <md-table-cell class="double-content">
                                <span class="first-content">{{ row.start | formatTimeStamp }}</span>
                                <span class="last-content visible-lsmall">{{ row.end | formatTimeStamp }}</span>
                            </md-table-cell>
                            <md-table-cell class="hidden-lsmall">
                                <span>{{ row.end | formatTimeStamp }}</span>
                            </md-table-cell>
                            <md-table-cell class="hidden-mobile">
                                <span>{{ row.reason }}</span>
                            </md-table-cell>
                            <md-table-cell class="actions">
                                <md-icon class="icon-edit raised" @click.native="openDialog('edit', row, rowIndex)">edit</md-icon>
                                <md-icon class="icon-delete raised" @click.native="remove(row, rowIndex)">delete</md-icon>
                            </md-table-cell>
                        </md-table-row>
                    </md-table-body>
                </md-table>
                <md-dialog md-open-from="#custom" md-close-to="#custom" ref="edit"
                    :md-click-outside-to-close="close"
                    :md-esc-to-close="close">
                    <md-dialog-content>
                        <h3 class="dialog--title">{{ translate.pages.extrahours.index.edit.title }}</h3>
                        <hr>
                        <div class="content-main">
                            <md-layout md-gutter class="modal-wrap">
                                <md-layout md-flex="100" class="container">
                                    <md-input-container style="margin-bottom: 5px" :class="{ 'md-input-invalid' : errors.office.invalid }">
                                        <label>{{ translate.pages.extrahours.index.edit.fields.consult }}</label>
                                        <md-select name="office" id="office" v-model="currentExtraHours.office">
                                            <md-option v-for="office in offices" :value="office.id" :key="office.id">{{ office.name }}</md-option>
                                        </md-select>
                                        <span class="md-error" v-if="errors.office.invalid">{{ errors.office.msg }}</span>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                                    <label>{{ translate.pages.extrahours.index.edit.fields.start_date }}</label>
                                    <md-icon class="icon-calendar">today</md-icon>
                                    <date-picker :option="option" :limit="limit" class="picker" :date="startDate" v-model="currentExtraHours.start_date"></date-picker>
                                    <small class="small-error" v-if="errors.start_date.invalid">{{ errors.start_date.msg }}</small>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                    <label>{{ translate.pages.extrahours.index.edit.fields.start_time }}</label>
                                    <md-icon>query_builder</md-icon>
                                    <vue-timepicker class="timer" v-model="currentExtraHours.start_time_value" format="HH:mm" @change="updateTime($event, 'start_time')"></vue-timepicker>
                                    <span class="span-error">{{ errors.start_time.msg }}</span>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                                    <label>{{ translate.pages.extrahours.index.edit.fields.end_date }}</label>
                                    <md-icon class="icon-calendar">today</md-icon>
                                    <date-picker :option="option" :limit="limit" class="picker" :date="endDate" v-model="currentExtraHours.end_date"></date-picker>
                                    <small class="small-error" v-if="errors.end_date.invalid">{{ errors.end_date.msg }}</small>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                    <label>{{ translate.pages.extrahours.index.edit.fields.end_time }}</label>
                                    <md-icon>query_builder</md-icon>
                                    <vue-timepicker class="timer" v-model="currentExtraHours.end_time_value" format="HH:mm" @change="updateTime($event, 'end_time')"></vue-timepicker>
                                    <span class="span-error">{{ errors.end_time.msg }}</span>
                                </md-layout>
                                <md-layout md-flex="100" class="container">
                                    <md-checkbox md-theme="green" class="md-primary checkbox-list" id="interval" name="interval" v-model="currentExtraHours.interval">
                                        <strong>{{ translate.pages.extrahours.index.edit.checkbox.strong }}</strong>
                                        <span class="color_form_placeholder normal">&nbsp;&nbsp;&nbsp; {{ translate.pages.extrahours.index.edit.checkbox.span }}</span>
                                    </md-checkbox>
                                </md-layout>
                                <md-layout md-flex="100" class="container">
                                    <md-input-container :class="{ 'md-input-invalid' : errors.reason.invalid }">
                                        <label>{{ translate.pages.extrahours.index.edit.reason }}</label>
                                        <md-input type="text" v-model="currentExtraHours.reason" required></md-input>
                                        <span class="md-error" v-if="errors.reason.invalid">{{ errors.reason.msg }}</span>
                                    </md-input-container>
                                </md-layout>
                            </md-layout>
                        </div>
                    </md-dialog-content>
                    <md-dialog-actions class="modal--footer">
                        <md-button class="float-l md-primary sm-size md-size" @click.native="closeDialog('edit')">{{ translate.pages.extrahours.index.edit.cancel }}</md-button>
                        <md-button class="float-r md-primary sm-size md-size btn--blue" @click.native="closeDialog('edit', true)" :disabled="process">{{ translate.pages.extrahours.index.edit.save }}</md-button>
                    </md-dialog-actions>
                </md-dialog>
            </md-table-card>
            <div v-else>
                <h3 class="not-found mini-found" v-if="search.isQuery">{{translate.pages.extrahours.index.no_result}} "<strong>{{ search.query }}".</strong></h3>
                <h3 v-else>
                    <span class="not-found mini-found" v-if="fetchData">{{ translate.pages.extrahours.index.no_records }}</span>
                    <span v-else>
                        <div class="sk-rotating-plane"></div>
                    </span>
                </h3>
            </div>
        </div>
    </div>
</template>
<script>
    const swal = require('sweetalert2');
    import { doctor } from '../../../config/api.js';
    import moment from 'moment';
    import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue';
    import { datepicker, options } from '../../../config/datepicker.js';
    import VueTimepicker from 'vue2-timepicker';
    export default {
        data: () => ({
            startDate: { time: datepicker.now_format},
            endDate: { time: datepicker.now_format},
            option: options,
            limit: [
                {
                    type: 'fromto',
                    from: moment().subtract(1, "days"),
                    to: ''
                }
            ],
            extraHours: [],
            offices: [],
            currentExtraHours: {},
            errors: {
                'office': {
                    'invalid': false,
                    'msg': ''
                },
                'start_date': {
                    'invalid': false,
                    'msg': ''
                },
                'start_time': {
                    'invalid': false,
                    'msg': ''
                },
                'end_date': {
                    'invalid': false,
                    'msg': ''
                },
                'end_time': {
                    'invalid': false,
                    'msg': ''
                },
                'reason': {
                    'invalid': false,
                    'msg': ''
                },
                'response': {
                    'invalid': false,
                    'msg': ''
                }
            },
            selectedData: [],
            fetchData: false,
            currentIndex: -1,
            disabled: true,
            close: false,
            addButton: true,
            sort: {},
            page: {},
            search: {
                query: '',
                queryIsDirty: false,
                isCalculating: false,
                isQuery: false
            },
            process: false,
        }),
        computed: {
            // Search indicator
            searchIndicator: function () {
                if (this.search.isCalculating) {
                    return '⟳'
                } else if (this.search.queryIsDirty) {
                    return '...'
                } else {
                    return '✓'
                }
            },
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get Lang
            lang(){
                return this.$store.getters.language.lang;
            },
            // Get path office
            path() {
                if(!this.currentOffice.path){
                    return 'https://api.agendaenlinea.cl/image/default_avatar.png';
                }
                return this.currentOffice.path;
            }
        },
        created() {
            let url = doctor.api.extraHours;
            let url_offices = doctor.api.offices;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
                url_offices += '?parent=' + parent;
            }
            // Get extra hours
            this.$http.get(url,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    // storage comunities
                    this.extraHours = data;
                    this.fetchData = true;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            // Get offices
            this.$http.get(url_offices,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    // storage comunities
                    this.offices = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        methods: {
            // Get path avatar
            srcImage(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            },
            // Open Modal
            openDialog(ref, row, rowIndex) {
                this.$refs[ref].open();
                this.currentIndex = rowIndex;
                let _row = JSON.parse(JSON.stringify(row));
                let _start_date = moment(_row.start);
                let _end_date = moment(_row.end);
                let interval = false;
                if(_row.interval){
                    interval = true;
                }
                this.startDate.time = _start_date.format('DD/MM/YYYY');
                this.endDate.time = _end_date.format('DD/MM/YYYY');
                this.currentExtraHours = {
                    'start_date': this.startDate.time,
                    'start_time': _start_date.format('HH:mm'),
                    'start_time_value': { HH: _start_date.format('HH'), mm: _start_date.format('mm') },
                    'end_date': this.endDate.time,
                    'end_time': _end_date.format("HH:mm"),
                    'end_time_value': { HH: _end_date.format('HH'), mm: _end_date.format('mm') },
                    'reason': _row.reason,
                    'office': _row.office_id,
                    'interval': interval,
                    'id': _row.id
                }
            },
            // Close Modal
            closeDialog(ref, save) {
                if(save)
                {
                    this.update(ref);
                }else{
                    this.currentIndex = -1;
                    this.$refs[ref].close();
                }
            },
            // Route add Extra Hour
            addExtraHours() {
                this.$router.push({'name': 'ExtraHoursAdd'});
            },
            // Validate addButton
            onSelect(data) {
                this.selectedData = data;
                this.$forceUpdate();
                (_.size(this.selectedData) >= 1) ? this.addButton = false : this.addButton = true;
            },
            // Sort offices
            onSort(sort) {
                this.offices = _.orderBy(this.offices, [item => item[sort.name]], sort.type);
            },
            // Pagination
            onPagination(page) {
                this.page = page;
            },
            // Remove extra hour
            remove(row, rowIndex){
                swal(this.translate.pages.extrahours.index.swal.remove.title, this.translate.pages.extrahours.index.swal.remove.message, 'warning')
                    .then( () => {
                        let url = doctor.api.extraHours + '/' + row.id;
                        let parent = this.$auth.getParent();
                        if(parent)
                        {
                            url += '?parent=' + parent;
                        }
                        this.$http.delete(url,{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.extraHours.splice(rowIndex, 1);
                                    }, (dismiss) => {
                                        this.extraHours.splice(rowIndex, 1);
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Remove Extra Hours
            removeExtraHours(){
                swal(this.translate.pages.extrahours.index.swal.removeOffices.title, this.translate.pages.extrahours.index.swal.removeOffices.message, 'warning')
                    .then( () => {
                        var promises = [];
                        for(let index in this.selectedData)
                        {
                            let url = doctor.api.extraHours + '/' + this.selectedData[index].id;
                            let parent = this.$auth.getParent();
                            if(parent)
                            {
                                url += '?parent=' + parent;
                            }
                            promises.push(this.$http.delete(url, {
                                            headers: {
                                                Authorization : 'Bearer '+ this.$auth.getToken(),
                                            }
                                        }));
                        }
                        Promise.all(promises)
                            .then(values => {
                                var msg = '';
                                var quantites = 0;
                                values.forEach( response => {
                                    if(response.status == 200)
                                    {
                                        msg = response.data.msg;
                                        quantites++;
                                        let url = response.config.url;
                                        let id = url.split("/extra-hours/")[1];
                                        this.extraHours.forEach( (extraHour,index) => {
                                            if(extraHour.id == id){
                                                this.extraHours.splice(index,1);
                                            }
                                        });
                                    }else{
                                        // Not deleted
                                    }
                                });
                                swal('', quantites + msg.substring(1), 'success')
                                    .then( () => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    }, (dismiss) => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    });
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Method to search
            expensiveOperation: _.debounce( function() {
                this.search.isCalculating = true;
                var self = this;
                let data = {'query': this.search.query, 'type': 'extra-hours'};
                let url = doctor.api.search;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.post(url, data, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.extraHours = data;
                    this.search.isCalculating = false;
                    this.search.queryIsDirty = false;

                    this.search.isQuery = self.search.query.length > 0;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            }, 500),
            // Update ExtraHours
            update(ref){
                let error = false;
                this.currentExtraHours.start_date = this.startDate.time;
                this.currentExtraHours.end_date = this.endDate.time;
                if(this.currentExtraHours.office.length == 0)
                {
                    this.errors.office.invalid = true;
                    this.errors.office.msg = this.translate.pages.extrahours.index.validations.office;
                    error = true;
                }else{
                    this.errors.office.invalid = false;
                    this.errors.office.msg = "";
                }
                if(this.currentExtraHours.start_date.length == 0)
                {
                    this.errors.start_date.invalid = true;
                    this.errors.start_date.msg = this.translate.pages.extrahours.index.validations.start_date;
                    error = true;
                }else{
                    this.errors.start_date.invalid = false;
                    this.errors.start_date.msg = "";
                }
                if(this.currentExtraHours.start_time.length == 0)
                {
                    this.errors.start_time.invalid = true;
                    this.errors.start_time.msg = this.translate.pages.extrahours.index.validations.start_time;
                    error = true;
                }else{
                    this.errors.start_time.invalid = false;
                    this.errors.start_time.msg = "";
                }
                if(this.currentExtraHours.end_date.length == 0)
                {
                    this.errors.end_date.invalid = true;
                    this.errors.end_date.msg = this.translate.pages.extrahours.index.validations.end_date;
                    error = true;
                }else{
                    this.errors.end_date.invalid = false;
                    this.errors.end_date.msg = "";
                }
                if(this.currentExtraHours.end_time.length == 0)
                {
                    this.errors.end_time.invalid = true;
                    this.errors.end_time.msg = this.translate.pages.extrahours.index.validations.end_time;
                    error = true;
                }else{
                    this.errors.end_time.invalid = false;
                    this.errors.end_time.msg = "";
                }
                if(this.currentExtraHours.reason.length == 0)
                {
                    this.errors.reason.invalid = true;
                    this.errors.reason.msg = this.translate.pages.extrahours.index.validations.office;
                    error = true;
                }else{
                    this.errors.reason.invalid = false;
                    this.errors.reason.msg = "";
                }
                if(error){
                    return false;
                }
                // udpate Extrahours
                this.process = true;
                let url = doctor.api.extraHours + '/' + this.currentExtraHours.id;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.put(url, this.currentExtraHours, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.extraHours[this.currentIndex] = response.data.data;
                        this.currentExtraHours = {};
                        this.$refs[ref].close();
                        this.currentIndex = -1;
                        swal('', response.data.msg, 'success');
                    }).catch(error => {
                        this.process = false;
                        if(error.response.status === 422){
                            let data = error.response.data;
                            for(let index in data)
                            {
                                this.errors[index].invalid = true;
                                let messages = '';
                                data[index].forEach( item => messages += item + ' ');
                                this.errors[index].msg = messages;
                            }
                            this.errors.response.invalid = false;
                        }else if(error.response.status === 404){
                            this.errors.response.invalid = true;
                            this.errors.response.msg = error.response.data.message;
                        }
                    });
            },
            // Update Time
            updateTime($event, target){
                this.currentExtraHours[target] = $event.data.HH + ':' + $event.data.mm;
            }
        },
        watch: {
            // Search query
            'search.query': function () {
                this.search.queryIsDirty = true;
                this.expensiveOperation();
            }
        },
        components: {
            'date-picker': myDatepicker,
            VueTimepicker
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/loading.styl'
    .Office
        .search
            display flex
            padding 1em
            .icon
                text-align center
                width 50px
            .input
                width 100%
                input
                    border 0
                    height 2em
                    width 100%
            .button
                background-color color_main
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_main
                    color white
            .button-remove
                background-color color_error
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_error
                    color white
            .status
                color color_form_placeholder
                font-size 1.5em
                left 0.35em
                position absolute
                top 0.75em
        .table
            padding 3em 2em 2em 2em
            .img
                border-radius 50%
            .name
                margin-left .5em
            .text-center
                text-align center
            .icon-edit
                color color_notifications
                cursor pointer
                font-size 22px
            .icon-delete
                color color_error
                cursor pointer
                font-size 22px
            .enabled
                border 1px solid color_form_placeholder
                border-radius 1em
                color color_form_placeholder
                margin 0 auto
                padding 0.5em 1.5em
                text-align center
                width 110px
                &.active
                    border 1px solid color_confirm
                    color color_confirm
    .content-main
        .container
            padding 0.25em 1em
            .picture
                position relative
                .icon
                    background-color color_main
                    border 3px solid white
                    border-radius 50%
                    bottom -1em
                    cursor pointer
                    height 40px
                    padding 8px
                    position absolute
                    right -1em
                    width 40px
                    text-align center
                    i
                        color white
                        position relative
                        left -3px
                        top -3px
            .multiple
                border 1px solid color_form_border
                border-radius 5px
                width 100%
                .title
                    margin 0.5em
                    color color_form_placeholder
                .select
                    overflow-y scroll
                    overflow-x hidden
                    margin 0.25em
                    height 110px
                    .option
                        width 95%
                        margin 0.25em
            .subtitle
                margin-top .5em
                color color_form_placeholder
            .w100
                width 100%
            .w90
                width 90%
            .w10
                width 10%
                margin-top 0
            .span-error
                color #ff5722
    .color_form_placeholder
        color color_form_placeholder
    @import '../../../assets/styles/responsive.styl'
    @media(max-width: 390px)
        .sm-size
            padding 0 1em!important
</style>



// WEBPACK FOOTER //
// Index.vue?4d5516f4